function Tonga({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2328)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M10.4348 8.34866V6.26172H8.3478V8.34866H6.26086V10.4357H8.3478V12.5226H10.4348V10.4357H12.5217V8.34866H10.4348Z" fill="#D80027"/>
  <path d="M16 0V16C7.1635 16.0001 3.65156 16 0 16.0001C0 24.8365 7.1635 32 16 32C24.8365 32 32 24.8365 32 16C32 7.1635 24.8365 0 16 0Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Tonga;
